import React from 'react';
import config from '../../../../config';
import Header from '../../../components/Header/Header';
import Toolbar from '../../../components/Toolbar/Toolbar';
import Table from '../../../components/Table/Table';
import NavBar from '../../../components/NavBar/NavBar';
import NumberFilter from '@inovua/reactdatagrid-community/NumberFilter';
import * as Yup from 'yup';
import BoolFilter from '@inovua/reactdatagrid-community/BoolFilter';
import { Switch } from '@mui/material';
import DateFilter from '@inovua/reactdatagrid-community/DateFilter';
import { useTranslation } from 'react-i18next';

const SubscriptionGroup = () => {
  const urls = {
    list: config.SUBSCRIPTION_GROUP,
    create: config.SUBSCRIPTION_GROUP,
    update: config.SUBSCRIPTION_GROUP_WITH_ID,
    delete: config.SUBSCRIPTION_GROUP_WITH_ID
  };
  const resource = 'PRODUCT';
  const { t } = useTranslation();

  const columns = [
    {
      header: t('id'),
      name: 'subscriptionGroupId',
      type: 'number',
      filterEditor: NumberFilter
    },
    {
      header: t('name'),
      name: 'subscriptionGroupName',
      type: 'string',
      validationSchema: Yup.string().max(255).required('Name is required'),
      isEditable: true,
      required: true,
      defaultFlex: 1
    },
    {
      header: t('description'),
      name: 'subscriptionGroupDescription',
      type: 'string',
      validationSchema: Yup.string().max(255),
      isEditable: true,
      required: true,
      defaultFlex: 1
    },
    {
      header: t('is.active'),
      name: 'isActive',
      type: 'boolean',
      isEditable: true,
      filterEditor: BoolFilter,
      render: ({ value }) => <Switch disabled checked={value} />
    },
    {
      header: t('date.added'),
      name: 'dateAdded',
      type: 'date',
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    },
    {
      header: t('date.modified'),
      name: 'dateModified',
      type: 'date',
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    }
  ];

  return (
    <>
      <Header title={t('subscription.groups')} />
      <Toolbar iamResource={resource} />
      <Table
        iamResource={resource}
        uniqueId={'subscriptionGroupId'}
        tableId={'subscriptionGroup'}
        columns={columns}
        urls={urls}
      />
      <NavBar />
    </>
  );
};

export default SubscriptionGroup;
